import React from 'react';

const PageWrapper = ({ children }) => (
  <section id="wrapper">{children}</section>
);

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js